function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { MedianPriceCard } from '@domain-group/fe-co-allhomes-shared-components';
import { medianPriceDataProps, medianStatProps } from '../common-props';
import LineGraph from './line-graph';
import { lineGraphHeight } from '../allhomes-listing-suburb-stats.style';
import * as styles from './median-sales.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var MedianSales = _ref => {
  var medianPriceData = _ref.medianPriceData,
    medianStatistics = _ref.medianStatistics,
    disableAnimation = _ref.disableAnimation,
    height = _ref.height;
  // Colours need to be resolved only during client-side render.
  var _useState = useState({
      resolved: false
    }),
    _useState2 = _slicedToArray(_useState, 2),
    colours = _useState2[0],
    setColours = _useState2[1];
  useEffect(() => {
    if (!colours.resolved) {
      setColours({
        resolved: true,
        colours: styles.colours()
      });
    }
  }, [colours.resolved]);
  return ___EmotionJSX(React.Fragment, null, medianStatistics && colours.resolved && ___EmotionJSX("div", {
    css: styles.legend
  }, ___EmotionJSX(MedianPriceCard, {
    appearance: "horizontal",
    statistics: medianStatistics,
    roundels: true,
    colours: colours.colours
  })), medianPriceData && colours.resolved && ___EmotionJSX(LineGraph, {
    data: medianPriceData,
    colours: colours.colours,
    options: {
      disableAnimation
    },
    height: height
  }));
};
MedianSales.propTypes = {
  medianPriceData: PropTypes.shape(medianPriceDataProps),
  medianStatistics: PropTypes.shape(medianStatProps),
  disableAnimation: PropTypes.bool,
  height: PropTypes.number
};
MedianSales.defaultProps = {
  medianPriceData: null,
  disableAnimation: false,
  height: lineGraphHeight,
  medianStatistics: {}
};
export default MedianSales;